import Turbolinks from 'turbolinks'

const handleAjaxError = (event) => {
  const parser = new DOMParser()
  const doc = parser.parseFromString(event.detail[2].responseText, 'text/html')
  document.documentElement.replaceChild(doc.body, document.body)
  Turbolinks.dispatch('turbolinks:load')
}

const mounted = (el) => {
  el.addEventListener('ajax:error', handleAjaxError)
}

const unmounted = (el) => {
  el.removeEventListener('ajax:error', handleAjaxError)
}

export default {
  mounted,
  unmounted
}
